/*Import Estilo*/
import './index.scss';
import '../../css/global.css';
import '../../css/normalize.css';

/*Import Bibliotecas*/
import { useNavigate, useLocation } from 'react-router-dom';
import React, { useState, useEffect, useRef } from 'react';

/*Import Componentes*/
import Cabecalho from '../../components/Cabecalho';
import CookieConsent from '../../components/CookieAceite';
import Rodape from '../../components/Rodape';

/*Import Requisição API*/
import api from '../../api';

export default function InserirCodigo() {
    const navigate = useNavigate();
    const location = useLocation();
    const { email } = location.state || {};
    const [codigo, setCodigo] = useState(Array(6).fill(''));
    const [texto, setTexto] = useState('');
    const [modalAberto, setModalAberto] = useState(false);
    const [loading, setLoading] = useState(false);
    const [cooldown, setCooldown] = useState(60);
    const caixaDeDialogo = useRef(null);

    useEffect(() => {
        caixaDeDialogo.current = document.getElementById("CaixaDeDialogo");
    }, []);

    const fecharModal = () => {
        if (caixaDeDialogo.current) {
            caixaDeDialogo.current.close();
        }
    };

    const mostrarModal = () => {
        if (caixaDeDialogo.current) {
            caixaDeDialogo.current.showModal();
        }
    };

    const formatarTempo = (segundos) => {
        const minutos = Math.floor(segundos / 60).toString().padStart(2, '0');
        const segundosRestantes = (segundos % 60).toString().padStart(2, '0');
        return `${minutos}:${segundosRestantes}`;
    };

    const reenviarCodigo = async (e) => {
        e.preventDefault();

        try {
            await api.post('/requisicao-resetar-senha', { email });
            setTexto('Código de resetar senha enviado com sucesso! Verifique sua caixa de entrada ou (spam/lixeira)');
            mostrarModal();
            setCooldown(60);
        } catch (error) {
            console.error('Erro ao reenviar código:', error);
            setTexto('Erro ao enviar código. Tente novamente.');
            mostrarModal();
        }
    };

    useEffect(() => {
        if (cooldown > 0) {
            const intervalo = setInterval(() => {
                setCooldown((prevCooldown) => prevCooldown - 1);
            }, 1000);
            return () => clearInterval(intervalo);
        }
    }, [cooldown]);

    if (!email) {
        navigate('/esqueciasenha');
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const codigoString = codigo.join('');
        try {
            const response = await api.post('/verificar-codigo-resetar-senha', { email, codigo: codigoString });
            setTexto(response.data.message);

            const { token } = response.data;
            if (token) {
                navigate(`/resetar-senha/${token}`, { state: { email } });
            } else {
                setTexto('Token não encontrado.');
                mostrarModal();
            }
        } catch (error) {
            setTexto(error.response?.data?.message || 'Ocorreu um erro ao verificar o código.');
            mostrarModal();
        }
    };

    const handleInputChange = (e, index) => {
        const { value } = e.target;

        if (value.length > 1) {
            handlePastedData(value);
        } else if (/^\d$/.test(value) || value === '') {
            const newCodigo = [...codigo];
            newCodigo[index] = value;
            setCodigo(newCodigo);

            if (value && index < 5) {
                document.getElementById(`input-${index + 1}`).focus();
            }
        }
    };

    const handlePaste = (e, index) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData('text');
        const digits = pastedData.split('').slice(0, 6);

        const newCodigo = [...codigo];

        for (let i = 0; i < digits.length; i++) {
            if (i < newCodigo.length) {
                newCodigo[i] = digits[i];
            }
        }

        setCodigo(newCodigo);
    };

    const handlePastedData = (value) => {
        const newCodigo = [...codigo];
        const pastedDigits = value.split('').filter(char => /^\d$/.test(char)).slice(0, 6);

        for (let i = 0; i < pastedDigits.length; i++) {
            if (i < newCodigo.length) {
                newCodigo[i] = pastedDigits[i];
            }
        }

        setCodigo(newCodigo);
        document.getElementById(`input-${Math.min(pastedDigits.length - 1, 5)}`).focus();
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            if (codigo[index] === "" && index > 0) {
                const newCodigo = [...codigo];
                newCodigo[index - 1] = "";
                setCodigo(newCodigo);
                document.getElementById(`input-${index - 1}`).focus();
            } else if (index > 0) {
                const newCodigo = [...codigo];
                newCodigo[index] = "";
                setCodigo(newCodigo);
            }
        }
    };

    const voltarInserirEmail = () => {
        navigate('/esqueciasenha');
    }

    return (
        <section className='containerPrincipalInserirCodigo'>
            <Cabecalho />
            <CookieConsent />
            <main>
                <section className='conteudoMainInserirCodigo'>
                    {loading ? (
                        <div className="loading">
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24"><path fill="#fff" d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity="0.25" /><path fill="#fff" d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z"><animateTransform attributeName="transform" dur="0.75s" repeatCount="indefinite" type="rotate" values="0 12 12;360 12 12" /></path></svg>
                        </div>
                    ) : (
                        <>
                            <ul class="iconResetPassword">
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                            </ul>
                            <dialog id="CaixaDeDialogo">
                                <div className='conteudo-dialog'>
                                    <div className="dialog-texto">
                                        <p>{texto}</p>
                                        <button onClick={fecharModal}>
                                            Ok
                                        </button>
                                    </div>
                                </div>
                            </dialog>

                            <div className='box-InseirCodigo'>
                                <h1>Insira o código</h1>
                                <h2>Enviado para o seu e-mail: </h2>
                                <div className='container-EmailOuEditar'>
                                    <h3>{email}</h3>
                                    <button onClick={voltarInserirEmail} id='bnt-EditarEmail'><img src='/assets/image/editarIcon.svg' />Alterar</button>
                                </div>
                                <form onSubmit={handleSubmit}>
                                    <div className="code-inputs-container">
                                        {Array(6).fill().map((_, index) => (
                                            <input
                                                key={index}
                                                id={`input-${index}`}
                                                type="text"
                                                maxLength="1"
                                                value={codigo[index] || ""}
                                                onChange={(e) => handleInputChange(e, index)}
                                                onKeyDown={(e) => handleKeyDown(e, index)}
                                                onPaste={(e) => handlePaste(e, index)}
                                                className="digit-input"
                                            />
                                        ))}
                                    </div>
                                    <button className='bnt-EnviarCodigo' type="submit">Validar Código</button>
                                    <button className={`bnt-ReEnviarCodigo ${cooldown > 0 ? 'bloqueado' : ''}`}
                                        onClick={reenviarCodigo}
                                        disabled={cooldown > 0}
                                    >
                                        {cooldown > 0 ? `Reenviar em ${formatarTempo(cooldown)}` : 'Reenviar Código'}
                                    </button>
                                </form>
                            </div>
                        </>
                    )}
                </section>
            </main>
            <Rodape />
        </section>
    );
}
